




























import {
  DesignedItemModel,
  designedItems,
} from '@web/models/HomeModels/DesignedItemModel';
import { Component } from 'vue-property-decorator';
import HomeSection from './Section.abstract';

@Component
export default class HomeDesigned extends HomeSection {
  imagesAppeareence = true;

  headersAppearence = true;

  imagesRefs = {
    safe: 'safe',
    time: 'time',
    check: 'check',
    home: 'home',
  };

  headersRefs = {
    header: 'header',
  };

  public designedItems: DesignedItemModel[] = designedItems;
}
